import { render, staticRenderFns } from "./CreateDocsDialog.vue?vue&type=template&id=6b1fe677"
import script from "./CreateDocsDialog.vue?vue&type=script&lang=js"
export * from "./CreateDocsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports